import { push, ref, remove } from "firebase/database";
import { database } from "../services/Firebase";
import "../styles/questions.scss"
import { useContext } from "react";
import { AuthContext } from "../App";

type QuestionsProps = {
    chave: string,
    content: string,
    author: {
        name: string,
        avatar: string,
    },
    roomId: string,
    likeCount: number,
    hasLiked: string | undefined,
    admin: boolean
}

export function Questions({chave, content, author, roomId, likeCount, hasLiked, admin}: QuestionsProps) {
    const {user} = useContext(AuthContext);

    async function handleLike() {
        if(hasLiked) {
            remove(ref(database, `/rooms/${roomId}/questions/${chave}/likes/${hasLiked}`));
        } else {
            push(ref(database, `/rooms/${roomId}/questions/${chave}/likes/`), {authorId: user?.id});
        }
    }

    function removePost() {
        if(window.confirm("Tem certeza que deseja excluir esta pergunta?")) {
            remove(ref(database, `rooms/${roomId}/questions/${chave}`));
        }
    }

    return (
        <div id="post">
            <p id="p">{content}</p>
            <footer id="footer">
                <div>
                    <img src={author?.avatar} alt="Avatar do usuário" />
                    <div>{author?.name}</div>
                </div>
                {admin?
                    <div id="footer-logolike">
                        <button onClick={removePost} id="delete-question">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6H5H21" stroke="#737380" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#737380" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </button>
                    </div>
                    :
                    <div id="footer-logolike">
                        {likeCount > 0 && <div>{likeCount}</div>}
                        <button className={`${hasLiked ? "liked" : ""}`} onClick={handleLike} type="button" aria-label="Marcar como gostei">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V13C2 12.4696 2.21071 11.9609 2.58579 11.5858C2.96086 11.2107 3.46957 11 4 11H7M14 9V5C14 4.20435 13.6839 3.44129 13.1213 2.87868C12.5587 2.31607 11.7956 2 11 2L7 11V22H18.28C18.7623 22.0055 19.2304 21.8364 19.5979 21.524C19.9654 21.2116 20.2077 20.7769 20.28 20.3L21.66 11.3C21.7035 11.0134 21.6842 10.7207 21.6033 10.4423C21.5225 10.1638 21.3821 9.90629 21.1919 9.68751C21.0016 9.46873 20.7661 9.29393 20.5016 9.17522C20.2371 9.0565 19.9499 8.99672 19.66 9H14Z" stroke="#737380" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        </button>
                    </div>
                }
            </footer>
        </div>
    );
}